import React, { useEffect, useState } from 'react';
import moment from 'moment';
import MonthlyDateSelect from '../../../../components/AppInput/MonthlyDateSelect';
import CalculateHours from '../../../../components/CalculateHours';
import CalculateTotalWorkingHours from '../../../../components/CalculateTotalWorkingHours';
import essPunchServices from '../essPunchServices';
import { useAppData } from '../../../../context/AppDataContext';
import { Link } from 'react-router-dom';
import { LocationOff, PinDrop, Verified, Warning } from '@mui/icons-material';

function EssPunchData() {
    const [punchList, setPunchList] = useState(null);
    const [filter, setFilter] = useState(null);
    const { employeeDD, getDDDataById } = useAppData();

    const getPunchList = () => {
        essPunchServices.getPunchList(filter).then(res => {
            setPunchList(res.data);
        }).catch(error => console.log(error));
    };

    useEffect(() => { getPunchList(); }, [filter]);

    return (
        <div className='container-fluid py-3'>
            {/* Header Section */}
            <div className='d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3'>
                <h5 className="mb-0 fw-bold">Attendance Logs</h5>
                <div className='ms-auto'>
                    <MonthlyDateSelect filter={filter} setFilter={setFilter} />
                </div>
            </div>

            {/* Desktop View (Hidden on small screens) */}
            <div className='d-none d-md-block shadow-sm rounded border bg-white'>
                <div className='table-responsive'>
                    <table className='table table-hover align-middle mb-0'>
                        <thead className='bg-light'>
                            <tr>
                                <th className="ps-4">Date</th>
                                <th>In Time</th>
                                <th>Out Time</th>
                                <th>Duration</th>
                                <th className="text-end pe-4">Status/Editor</th>
                            </tr>
                        </thead>
                        <tbody>
                            {punchList?.map((punch) => (
                                <tr key={punch.id} style={{ borderLeft: punch.updatedBy ? '4px solid #dc3545' : '4px solid transparent' }}>
                                    <td className="ps-4">
                                        <div className="fw-bold">{moment(punch.inTime).format("D MMM")}</div>
                                        <small className="text-muted">{moment(punch.inTime).format("dddd")}</small>
                                    </td>
                                    <td>
                                        <span className="badge bg-success-soft text-success">{moment(punch.inTime).format("h:mm A")}</span>
                                        {punch.inLat && punch.inLng ? (
                                            <Link to={`https://www.google.com/maps/search/?api=1&query=${punch.inLat},${punch.inLng}`} target="_blank" rel="noopener noreferrer">
                                              <span className='ms-2'><PinDrop /></span>
                                            </Link>
                                          ) : (
                                            <span className='ms-2'><LocationOff /></span>
                                          )
                                        }
                                        {punch.inStatus ? <Verified color='success' fontSize='small' /> : <Warning color='warning' fontSize='small' />}
                                    </td>
                                    <td>
                                        {punch.outTime ? 
                                            <div>
                                                <span className="badge bg-secondary-soft text-dark">
                                                    {moment(punch.outTime).format("h:mm A")}
                                                </span> 
                                                {punch.outLat && punch.outLng ? (
                                                    <Link to={`https://www.google.com/maps/search/?api=1&query=${punch.outLat},${punch.outLng}`} target="_blank" rel="noopener noreferrer">
                                                    <span className='ms-2'><PinDrop /></span>
                                                    </Link>
                                                ) : (
                                                    <span className='ms-2'><LocationOff /></span>
                                                )
                                                }
                                                {punch.outStatus ? <Verified color='success' fontSize='small' /> : <Warning color='warning' fontSize='small' />}
                                            </div>
                                            : <span className="text-muted small">--:--</span>
                                            
                                        }
                                    </td>
                                    <td className="fw-semibold">
                                        {punch.outTime ? <CalculateHours inTime={punch.inTime} outTime={punch.outTime} /> : "In Progress"}
                                    </td>
                                    <td className="text-end pe-4">
                                        {punch.updatedBy && (
                                            <small className='text-danger d-block' title="Manually Adjusted">
                                                <i className="bi bi-pencil-square me-1"></i>
                                                {getDDDataById(employeeDD, punch.updatedBy).label}
                                            </small>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Mobile View (Hidden on medium/large screens) */}
            <div className='d-md-none'>
                {punchList?.map((punch) => (
                    <div key={punch.id} className={`card mb-3 shadow-sm border-0 ${punch.updatedBy ? 'border-start border-danger border-4' : ''}`}>
                        <div className='card-body'>
                            <div className='d-flex justify-content-between mb-2'>
                                <span className='fw-bold text-primary'>{moment(punch.inTime).format("ddd, D MMM YYYY")}</span>
                                <span className='badge bg-light text-dark'>
                                    {punch.outTime ? <CalculateHours inTime={punch.inTime} outTime={punch.outTime} /> : "Active"}
                                </span>
                            </div>
                            <div className='row text-center bg-light rounded py-2 g-0'>
                                <div className='col-6 border-end'>
                                    <small className='text-muted d-block'>IN</small>
                                    <strong>{moment(punch.inTime).format("h:mm A")}</strong>
                                    {punch.inLat && punch.inLng ? (
                                        <Link to={`https://www.google.com/maps/search/?api=1&query=${punch.inLat},${punch.inLng}`} target="_blank" rel="noopener noreferrer">
                                          <span className='ms-2'><PinDrop /></span>
                                        </Link>
                                      ) : (
                                        <span className='ms-2'><LocationOff /></span>
                                      )
                                    }
                                    {punch.inStatus ? <Verified color='success' fontSize='small' /> : <Warning color='warning' fontSize='small' />}
                                </div>
                                <div className='col-6'>
                                    <small className='text-muted d-block'>OUT</small>
                                    <strong>{punch.outTime ? 
                                        <div>
                                                {moment(punch.outTime).format("h:mm A")}
                                                {punch.outLat && punch.outLng ? (
                                                    <Link to={`https://www.google.com/maps/search/?api=1&query=${punch.outLat},${punch.outLng}`} target="_blank" rel="noopener noreferrer">
                                                    <span className='ms-2'><PinDrop /></span>
                                                    </Link>
                                                ) : (
                                                    <span className='ms-2'><LocationOff /></span>
                                                )
                                                }
                                                {punch.outStatus ? <Verified color='success' fontSize='small' /> : <Warning color='warning' fontSize='small' />}
                                            </div>
                                        
                                        : 
                                        "--:--"}
                                    </strong>
                                </div>
                            </div>
                            {punch.updatedBy && (
                                <div className='mt-2 text-end'>
                                    <small className='text-danger italic'>Edited by: {getDDDataById(employeeDD, punch.updatedBy).label}</small>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {/* Summary Footer */}
            {punchList && (
                <div className='mt-4 p-3 bg-dark text-white rounded shadow-sm d-flex justify-content-between align-items-center'>
                    <span className='text-uppercase small fw-bold opacity-75'>Total Monthly Hours</span>
                    <h4 className='mb-0'><CalculateTotalWorkingHours punchList={punchList} /></h4>
                </div>
            )}
        </div>
    );
}

export default EssPunchData;